import Repository from '../Repository';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/channel`;
export default {
  /**
   * Returns a list of all channels the user has access to.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  getAll() {
    return Repository.get(`${base}/list`);
  },
  /**
   * Sets the selected channel as the current active one.
   *
   * @param channelId
   * @returns {Promise<AxiosResponse<T>>}
   */
  select(channelId) {
    return Repository.post(`${base}/select`, { id: channelId });
  },
};
